import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Slider } from "primereact/slider";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../utils/utils";
import { useQuery } from "@tanstack/react-query";
import { getStoreFilters } from './../../../../apis/requests';
import { Skeleton } from 'primereact/skeleton';
import useLang from "../../../../hooks/useLang";
const ShopFilters = (props) => {
    const lang = useLang();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [filterId, setFilterId] = useState(props.filterId);
    const [filterType, setFilterType] = useState(props.filterType);
    useEffect(() => {
        setFilterId(props.filterId);
        setFilterType(props.filterType);
    }, [props]);

    const { data, isLoading } = useQuery({
        queryKey: ["getShopFilters"],
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        queryFn: () => {
            return getStoreFilters();
        },
    });
    const filters = data?.data.filters || undefined;
    const [priceRange, setPriceRange] = useState([5, 200]);
    const [openNodes, setOpenNodes] = useState({});
    const toggleNode = (id) => {
        setOpenNodes((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    return (
        <div>
            {
                isLoading &&
                <FiltersLoading />
            }
            {
                !isLoading &&
                <div className="mx-4">
                    <h2 className="text-xl font-semibold text-[#004040] mb-2">
                        {t("browse_by_categories")}
                    </h2>
                    <ul className="text-sm">
                        {filters.categories.map((category) => (
                            <li key={category.id}>
                                <Link
                                    to={"/shop/category/" + category.id + "/" + (lang === "en" ? category.category_name : category.category_name_ar)}
                                    className="flex items-center gap-2 cursor-pointer py-1 hover:text-[#004040]"
                                    onClick={() => {
                                        toggleNode(category.id);
                                    }}
                                >
                                    <span className="material-symbols-outlined">
                                        {openNodes[category.id] ? "keyboard_arrow_down" : (lang === "en" ? "chevron_forward" : "chevron_backward")}
                                    </span>
                                    <span
                                        style={{
                                            fontWeight: filterType === "category" && filterId == category.id ? "bold" : "500",
                                            color: filterType === "category" && filterId == category.id ? "#004040" : "#000",
                                        }}
                                    >
                                        {lang === "en" ? category.category_name : category.category_name_ar}
                                    </span>
                                </Link>
                                {openNodes[category.id] && (
                                    <ul className={lang === 'en' ? "ml-6 border-l pl-3" : "mr-6 border-r pr-3"}>
                                        {category.sub_categories.map((subc) => (
                                            <li key={subc.id}>
                                                <Link
                                                    style={{
                                                        fontWeight: filterType === "sub-category" && filterId == subc.id ? "bold" : "500",
                                                        color: filterType === "sub-category" && filterId == subc.id ? "#004040" : "#000",
                                                    }}
                                                    to={"/shop/sub-category/" + subc.id + "/" + (lang === "en" ? subc.category_name : subc.category_name_ar)}
                                                    className="block py-1 hover:text-[#004040]"
                                                >
                                                    {lang === "en" ? subc.category_name : subc.category_name_ar}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                    <h2 className="text-xl font-semibold text-[#004040]">{t('browse_by_brands')}</h2>
                    <ul className="mx-4 text-sm" >
                        {
                            filters.brands.map((brand) => {
                                return (
                                    <li key={brand.id} className="my-2">
                                        <Link
                                            onClick={() => {
                                                props.onClose();
                                            }}
                                            to={"/shop/brand/" + brand.id + "/" + (lang === "en" ? brand.brand_name : brand.brand_name_ar)}
                                        >
                                            <span
                                                style={{
                                                    fontWeight: filterType === "brand" && filterId == brand.id ? "bold" : "500",
                                                    color: filterType === "brand" && filterId == brand.id ? "#004040" : "#000",
                                                }}
                                            >{lang === "en" ? brand.brand_name : brand.brand_name_ar}</span>
                                        </Link>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <div className="my-6">
                        <h2 className="text-xl font-semibold text-[#004040]">
                            {t("browse_by_price")}
                        </h2>
                        <Slider
                            min={5}
                            max={200}
                            value={priceRange}
                            onChange={(e) => setPriceRange(e.value)}
                            className="lg:w-70 my-4"
                            range
                        />
                        <div className="text-sm text-gray-700 mt-2 font-semibold">
                            {formatCurrency(priceRange[0])} - {formatCurrency(priceRange[1])}
                        </div>
                        <button
                            onClick={() => {
                                navigate('/shop/price/' + JSON.stringify(priceRange) + '/' + (formatCurrency(priceRange[0]) + ' - ' + formatCurrency(priceRange[1])));
                            }}
                            className="btn border border-2 border-[#004040] rounded-full px-6 py-2 my-4 font-semibold text-sm cursor-pointer">{t('apply')}</button>
                    </div>
                </div>
            }
        </div>
    );
};

export default ShopFilters;
const FiltersLoading = () => {
    return (
        <div>
            <Skeleton height="2rem" className="mb-2"></Skeleton>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="15rem" className="mb-2"></Skeleton>
            <Skeleton width="9rem" className="mb-2"></Skeleton>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="15rem" className="mb-2"></Skeleton>
            <Skeleton width="9rem" className="mb-2"></Skeleton>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="15rem" className="mb-2"></Skeleton>
            <Skeleton width="9rem" className="mb-2"></Skeleton>
            <Skeleton height="2rem" className="mb-2 mt-6"></Skeleton>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="15rem" className="mb-2"></Skeleton>
            <Skeleton width="9rem" className="mb-2"></Skeleton>
            <Skeleton height="2rem" className="mb-2 mt-6"></Skeleton>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="15rem" className="mb-2"></Skeleton>
            <Skeleton width="9rem" className="mb-2"></Skeleton>
            <Skeleton height="2rem" className="mb-2 mt-6"></Skeleton>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="15rem" className="mb-2"></Skeleton>
            <Skeleton width="9rem" className="mb-2"></Skeleton>
        </div>
    );
}